// POS product search, which is also the barcode scanner input (Stitches S8): a scanner types the
// variant SKU and presses Enter, and Enter adds the first enabled option. When the search text is
// exactly a variant SKU, only that variant is offered, so a scan never adds a lookalike (SH001 vs
// SH0011) or, when the scanned variant is out of stock, the next variant in the list.
export const filterPosSearchOptions = <Option extends { id: string; name: string; sku: string }>(
  options: Option[],
  searchValue: string,
): Option[] => {
  const normalizedSearchValue = searchValue.trim().toLowerCase();
  const exactSkuMatches = options.filter(
    (option) => !!normalizedSearchValue && option.sku.toLowerCase() === normalizedSearchValue,
  );
  if (exactSkuMatches.length > 0) return exactSkuMatches;
  return options.filter((option) => {
    const mergedValue = `${option.sku.toLowerCase()}::${option.name.toLowerCase()}::${option.id}`;
    return mergedValue.includes(searchValue.toLowerCase());
  });
};
